import { lazy } from "react";

export const CHUNK_RELOAD_KEY = "atomicpay:chunk-reload-attempted";

export function isStaleChunkError(error) {
  const message = String(error?.message || error || "");
  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /text\/html.*MIME type/i.test(message)
  );
}

export function isIndexedDbConnectionError(error) {
  const message = String(error?.message || error || "");
  return /indexed database server lost/i.test(message);
}

export function attemptChunkReload() {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    return false;
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  window.location.reload();
  return true;
}

export function lazyWithRetry(importFn) {
  return lazy(async () => {
    try {
      return await importFn();
    } catch (error) {
      if (isStaleChunkError(error) && attemptChunkReload()) {
        return new Promise(() => {});
      }
      throw error;
    }
  });
}

export function setupChunkLoadRecovery() {
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    attemptChunkReload();
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    if (!isStaleChunkError(reason) && !isIndexedDbConnectionError(reason)) {
      return;
    }
    event.preventDefault();
    attemptChunkReload();
  });

  window.addEventListener("load", () => {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  });
}
